export default (params) => ({
  trigger: {
    name: 'help_after_purchase.select_manual',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'prominent_above_the_fold',
          'prominent_below_the_fold',
          'regular',
          'less_prominent',
        ],
      },
    },
    event: {
      name: 'select_content',
    },
  },
});
